import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Amplify} from "aws-amplify";
import {BrowserRouter as Router} from "react-router-dom"

Amplify.configure({
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_TQ3WtBL77',
    userPoolWebClientId: 'jd4hp3taoeilfhln3hepdr7sl',
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Router>
    <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
